webpackJsonp([72],{

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_filters__ = __webpack_require__(278);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function goTo(route) {
	this.$router.push({ name: 'companies-' + route, params: { id: this.id } });
}

function data() {
	return {
		totalExpenses: 0
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'companies-statistics',
	data: data,
	filters: {
		round: __WEBPACK_IMPORTED_MODULE_0__shared_filters__["c" /* round */]
	},
	methods: {
		goTo: goTo
	},
	props: {
		id: {
			default: 0,
			type: [Number, String]
		}
	}
});

/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".header-booking-data[data-v-73ac834a]{height:31px;position:absolute;right:20px;text-align:right;top:59px;width:calc(100% - 230px)}.header-booking-data div[data-v-73ac834a]{padding-bottom:0!important;padding-top:0!important}.header-booking-data p[data-v-73ac834a]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-73ac834a]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.btn-tab[data-v-73ac834a]{border-bottom:3px solid transparent}.btn-tab.active[data-v-73ac834a],.btn-tab[data-v-73ac834a]:hover{border-color:#29abe2}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/companies/companies-statistics.vue"],"names":[],"mappings":"AACA,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,0CACI,2BAA+B,AAC/B,uBAA4B,CAC/B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,0BACE,mCAAqC,CACtC,AACD,iEACI,oBAAsB,CACzB","file":"companies-statistics.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.header-booking-data[data-v-73ac834a] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 59px;\n  width: calc(100% - 230px);\n}\n.header-booking-data div[data-v-73ac834a] {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n}\n.header-booking-data p[data-v-73ac834a] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-73ac834a] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.btn-tab[data-v-73ac834a] {\n  border-bottom: 3px solid transparent;\n}\n.btn-tab[data-v-73ac834a]:hover, .btn-tab.active[data-v-73ac834a] {\n    border-color: #29abe2;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1425);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("09b70767", content, true);

/***/ }),

/***/ 1671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.id) ? _c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('p', [_vm._v("Gasto Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.totalExpenses)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-edit'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('edit')
      }
    }
  }, [_vm._v("\n\t\t\t\tDetalle\n\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-statistics'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('statistics')
      }
    }
  }, [_vm._v("\n\t\t\t\tEstadística\n\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-history'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('history')
      }
    }
  }, [_vm._v("\n\t\t\t\tHistorial\n\t\t\t")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1510)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1274),
  /* template */
  __webpack_require__(1671),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73ac834a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/72.7878a10dc9a43da5d51b.js